import { oz } from '@weft/utils';
import { PageNumberSchema } from './page-number-schema';
import { PageSizeSchema } from './page-size-schema';

export const PaginationSchema = oz.object({
  page: PageNumberSchema,
  pageSize: PageSizeSchema,
});

export type PaginationInput = oz.infer<typeof PaginationSchema>;